import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyCTN1vaIdKQ1gDwe669NBuqN4gFos0H8hY",
  authDomain: "nhvelo-f0124.firebaseapp.com",
  projectId: "nhvelo-f0124",
  storageBucket: "nhvelo-f0124.appspot.com",
  messagingSenderId: "1008559856386",
  appId: "1:1008559856386:web:20405cb5860587cd7a801b",
  measurementId: "G-Q045WYG086"
};

export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const db = getFirestore(app);
export const storage = getStorage(app);